import { createFileRoute } from '@tanstack/react-router'
import MedicalHistoryTab from '@pages/donor-detail/ui/MedicalHistoryTab'
import { Loader } from '@/shared/ui/loader'
import { Suspense } from 'react'

function MedicalHistoryRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <MedicalHistoryTab visitId={visitId} />
    </Suspense>
  )
}

export const Route = createFileRoute(
  '/_protected/donors/$visitId/medical-history',
)({
  component: MedicalHistoryRoute,
})
